import { render, staticRenderFns } from "./OcrList.vue?vue&type=template&id=0af9d966&scoped=true"
import script from "./OcrList.vue?vue&type=script&lang=js"
export * from "./OcrList.vue?vue&type=script&lang=js"
import style0 from "./OcrList.vue?vue&type=style&index=0&id=0af9d966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af9d966",
  null
  
)

export default component.exports